import script from "./BillingReminder.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingReminder.vue?vue&type=script&setup=true&lang=js"

import "./BillingReminder.vue?vue&type=style&index=0&id=11696300&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11696300"]])

export default __exports__